export const DEFAULT_NEVISIGN_API_BASE = "/api/v1";

/** Legacy hosts — not used as local defaults. */
export const LEGACY_IP_API_BASE = "https://37.32.27.208/nevisign";
export const LEGACY_AIHUB_API_BASE = "https://aihub.mohaami.ir/nevisign";

/**
 * Local version check uses the platform reader adapter.
 * Remote OTA URLs remain as fallbacks for the native app.
 */
export const VERSION_JSON_URLS = [
  "/api/v1/reader/version",
] as const;

export const DEFAULT_VERSION_JSON_URL = VERSION_JSON_URLS[0];

/** Bundled app version (keep in sync with android/app/build.gradle). */
export const APP_VERSION_CODE = 21;
export const APP_VERSION_NAME = "1.20-tools-pdf-chat";
export const NEVISIGN_SITE_URL =
  (import.meta.env.VITE_MARKETING_URL as string | undefined)?.trim() ||
  (import.meta.env.VITE_NEVISIGN_SITE_URL as string | undefined)?.trim() ||
  "https://nevisign.ir";
